// extracted by mini-css-extract-plugin
module.exports = {"title":"CategoryItem_title__bIYa7","description":"CategoryItem_description__Bh1kr"};